<template>
    <div class="formulate-option-selector">
        <v-select ref="select" :class="`formulate-input-element formulate-input-element--${context.type}`" :data-type="context.type" :modelValue="context._value" @update:modelValue="handleInput" :options="context.options" :reduce="(x) => x.value" v-bind="context.attrs" :filterable="false" label="label" @close="onClose" @search="onSearch">
            <template #selected-option-container>
                <span class="noRender"></span>
            </template>

            <template #option="{ label }">
                <div class="formulate-option-selector__option">
                    <span class="option-label">{{ label }}</span>
                    <span class="icon icon--check--filled--inverted icon--shakespeare option-check"></span>
                </div>
            </template>

            <template #search="{ attributes, events }">
                <input placeholder="- Selecteer -" class="vs__search" v-bind="attributes" v-on="events" />
            </template>
        </v-select>
        <div class="formulate-option-selector__options">
            <div @click="onOptionClick(option)" v-for="option in selectedOptions" :key="option.id" class="button--option button">
                <span class="icon icon--cross icon--dark">remove</span>
                {{ option.label }}
            </div>
        </div>
    </div>
</template>

<script src="./FormulateAsyncOptionSelector.js"></script>
